import { render } from "./Ternakan.vue?vue&type=template&id=1a2a13d9"
import script from "./Ternakan.vue?vue&type=script&lang=js"
export * from "./Ternakan.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__